import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {FormsModule} from '@angular/forms';
import {provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import {environment} from '../environments/environment';
import {ApplicationService} from './services/application.service';
import {FileUploadServiceService} from './services/file-upload-service.service';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {StartComponent} from './start/start.component';
import {NavigationComponent} from './navigation/navigation.component';
import {HomeComponent} from './home/home.component';
import {LoadingComponent} from './modals/loading/loading.component';
import {ResumeComponent} from './modals/resume/resume.component';
import {StandbyApplicationComponent} from './modals/standby-application/standby-application.component';
import {DynamicInputFormComponent} from './dynamic-input-form/dynamic-input-form.component';
import {HeaderPanelComponent} from './header-panel/header-panel.component';
import {LoadApplicationComponent} from './load-application/load-application.component';
import {ReviewComponent} from './review/review.component';
import {ContactDisplayComponent} from './contact-display/contact-display.component';
import {CompleteComponent} from './complete/complete.component';
import {LoginComponent} from './modals/login/login.component';
import {HelpButtonComponent} from './help-button/help-button.component';
import {NgbDateAdapter, NgbDateNativeAdapter} from '@ng-bootstrap/ng-bootstrap';
import { ToTrustedPipe } from '@shared/pipes/to-trusted.pipe';
import {DisplayPipe} from '@shared/pipes/display.pipe';
import {DisplayFieldComponent} from '@shared/display-field/display-field.component';
import {DynamicInputComponent} from '@shared/dynamic-input/dynamic-input.component';
import {IsArrayPipe} from '@shared/pipes/is-array.pipe';
import {ErrorHandlingService} from '@shared/services/error-handling.service';
import {ToastComponent} from '@shared/toast/toast.component';

@NgModule({
  declarations: [
    AppComponent,
    NavigationComponent,
    HomeComponent,
    LoadingComponent,
    StartComponent,
    StandbyApplicationComponent,
    DynamicInputFormComponent,
    HeaderPanelComponent,
    LoadApplicationComponent,
    ResumeComponent,
    ReviewComponent,
    ContactDisplayComponent,
    CompleteComponent
  ],
  bootstrap: [AppComponent],
  imports: [BrowserModule,
    AppRoutingModule,
    FormsModule,
    // SharedModule,
    ToTrustedPipe,
    DisplayPipe,
    DisplayFieldComponent,
    DynamicInputComponent,
    HelpButtonComponent,
    IsArrayPipe,
    LoginComponent, ToastComponent
  ], providers: [
    ApplicationService,
    ErrorHandlingService,
    FileUploadServiceService,
    {provide: 'environment', useValue: environment},
    {provide: NgbDateAdapter, useClass: NgbDateNativeAdapter},
    provideHttpClient(withInterceptorsFromDi())
  ]
})
export class AppModule {
}
